import { render, staticRenderFns } from "./MultiAnnotationTablePopup.vue?vue&type=template&id=8e3800a8&scoped=true&"
import script from "./MultiAnnotationTablePopup.vue?vue&type=script&lang=js&"
export * from "./MultiAnnotationTablePopup.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/multi_ann_table_popup.scss?vue&type=style&index=0&id=8e3800a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3800a8",
  null
  
)

export default component.exports